/**
 * @file BcpAlert.js
 */
class BcpAlert {
  timeStamp;
  alerts;

  constructor(timeStamp, alerts) {
    this.timeStamp = timeStamp;
    this.alerts = alerts;
  }
}

export default BcpAlert;
